import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay'
import { DdpCta } from '@/components/shared/DdpCta';
import { THomeProps } from '../type';
import { DdpImage } from '@/components/shared/DdpImage';
import { TopBack } from '@/components/shared/TopBack';
import LanguageDropdown from '@/components/shared/LanguageDropdown';
export function HomeMaster(props: THomeProps) {
    const { title, description, cTA, imageSlide } = props
    return <div className='page-home page-container'>
        <div className='top-wrapper'>
            <LanguageDropdown wrapClass="language-dropdown" />
            <TopBack onClick={(e) => {
                e.stopPropagation()
            }} />
            <h1 className='title'>{title}</h1>
            <div className='description' dangerouslySetInnerHTML={{ __html: description }}></div>
            <DdpCta className='btn-next sm:hidden md:flex desk:flex' cta={cTA} />
        </div>
        <div className='bottom-wrapper'>
            <Swiper
                modules={[Autoplay]}
                autoplay={{
                    delay: 2000,
                }}
                breakpoints={{
                    320: {
                        spaceBetween: 20,
                        slidesPerView: 'auto',
                        direction: 'horizontal'
                    },
                    744: {
                        spaceBetween: 30,
                        slidesPerView: 'auto',
                        direction: 'horizontal'
                    },
                    1024: {
                        slidesPerView: 'auto',
                        spaceBetween: 32,
                        centeredSlides: true,
                        direction: 'vertical',
                        loop: true,
                    },
                }}
                onResize={(swiper) => {
                    swiper.updateSize()
                }}
            >
                {imageSlide.map((item, index) => (
                    <SwiperSlide key={`slide-${index}`} >
                        <DdpImage className='slide-img' image={item} />
                    </SwiperSlide>
                ))}
            </Swiper>

            <DdpCta className='btn-next sm:flex md:hidden desk:hidden' cta={cTA} />
        </div>
    </div >
}
